import { takeEvery, all, call, put } from 'redux-saga/effects';
import * as types from './orderSupplierActionTypes';
import * as actions from './orderSupplierActions';
import * as endpoints from '../../services/endpoints';
import * as alert from '../alert/alertActions';

function* getOrderSupplierSaga(action) {
  try {
    const { data } = yield call(endpoints.getOrderSupplier, action.payload);
    yield put(actions.getOrderSupplierSuccess(data));
  } catch (e) {
    yield put(actions.getOrderSupplierError(e));
  }
}

function* addOrderSupplierSaga(action) {
  try {
    const { data } = yield call(endpoints.addOrderSupplier, action.payload);
    yield put(actions.addOrderSupplierSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Tedarikçi başarıyla eklendi',
        variant: 'success',
      }));
      // Reload order suppliers after adding
      if (action.payload.OrderId) {
        yield put(actions.getOrderSupplierRequest({
          SessionUserId: action.payload.SessionUserId,
          OrderId: action.payload.OrderId
        }));
      }
      if (action.payload.onSuccess) {
        action.payload.onSuccess();
      }
    } else {
      yield put(alert.setAlertAction({
        title: 'Hata!',
        text: data.Result?.ErrorDescription || 'Tedarikçi eklenirken bir hata oluştu',
        variant: 'danger',
      }));
    }
  } catch (e) {
    yield put(actions.addOrderSupplierError(e));
    yield put(alert.setAlertAction({
      title: 'Hata!',
      text: 'Tedarikçi eklenirken bir hata oluştu',
      variant: 'danger',
    }));
  }
}

function* updateOrderSupplierSaga(action) {
  try {
    const { data } = yield call(endpoints.updateOrderSupplier, action.payload);
    yield put(actions.updateOrderSupplierSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Tedarikçi başarıyla güncellendi',
        variant: 'success',
      }));
      // Reload order suppliers after updating
      if (action.payload.OrderId) {
        yield put(actions.getOrderSupplierRequest({
          SessionUserId: action.payload.SessionUserId,
          OrderId: action.payload.OrderId
        }));
      }
      if (action.payload.onSuccess) {
        action.payload.onSuccess();
      }
    } else {
      yield put(alert.setAlertAction({
        title: 'Hata!',
        text: data.Result?.ErrorDescription || 'Tedarikçi güncellenirken bir hata oluştu',
        variant: 'danger',
      }));
    }
  } catch (e) {
    yield put(actions.updateOrderSupplierError(e));
    yield put(alert.setAlertAction({
      title: 'Hata!',
      text: 'Tedarikçi güncellenirken bir hata oluştu',
      variant: 'danger',
    }));
  }
}

function* deleteOrderSupplierSaga(action) {
  try {
    const { data } = yield call(endpoints.deleteOrderSupplier, action.payload);
    yield put(actions.deleteOrderSupplierSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Tedarikçi başarıyla silindi',
        variant: 'success',
      }));
      // Reload order suppliers after deleting
      if (action.payload.OrderId) {
        yield put(actions.getOrderSupplierRequest({
          SessionUserId: action.payload.SessionUserId,
          OrderId: action.payload.OrderId
        }));
      }
    } else {
      yield put(alert.setAlertAction({
        title: 'Hata!',
        text: data.Result?.ErrorDescription || 'Tedarikçi silinirken bir hata oluştu',
        variant: 'danger',
      }));
    }
  } catch (e) {
    yield put(actions.deleteOrderSupplierError(e));
    yield put(alert.setAlertAction({
      title: 'Hata!',
      text: 'Tedarikçi silinirken bir hata oluştu',
      variant: 'danger',
    }));
  }
}

// Batch add order suppliers (for multiple rows)
function* addOrderSupplierBatchSaga(action) {
  try {
    const { payloads, orderId, sessionUserId, onSuccess } = action.payload;

    // Process each payload
    for (const payload of payloads) {
      const { data } = yield call(endpoints.addOrderSupplier, payload);
      if (data.Result?.ErrorCode !== 0) {
        yield put(actions.addOrderSupplierBatchError(data.Result?.ErrorDescription
          || 'Operation failed'));
        yield put(alert.setAlertAction({
          title: 'Hata!',
          text: data.Result?.ErrorDescription || 'Tedarikçi eklenirken bir hata oluştu',
          variant: 'danger',
        }));
        return;
      }
    }

    yield put(actions.addOrderSupplierBatchSuccess());
    yield put(alert.setAlertAction({
      title: 'Başarılı!',
      text: 'Tedarikçiler başarıyla eklendi',
      variant: 'success',
    }));

    // Reload order suppliers after all added
    if (orderId) {
      yield put(actions.getOrderSupplierRequest({
        SessionUserId: sessionUserId,
        OrderId: orderId
      }));
    }

    if (onSuccess) {
      onSuccess();
    }
  } catch (e) {
    yield put(actions.addOrderSupplierBatchError(e));
    yield put(alert.setAlertAction({
      title: 'Hata!',
      text: 'Tedarikçiler eklenirken bir hata oluştu',
      variant: 'danger',
    }));
  }
}

function* getOrderSupplierDropdownSaga(action) {
  try {
    const { data } = yield call(endpoints.getOrderSupplierDropdown, action.payload);
    yield put(actions.getOrderSupplierDropdownSuccess(data));
  } catch (e) {
    yield put(actions.getOrderSupplierDropdownError(e));
  }
}

function* getOrderDropdownSaga(action) {
  try {
    const { data } = yield call(endpoints.getOrderDropdown, action.payload);
    yield put(actions.getOrderDropdownSuccess(data));
  } catch (e) {
    yield put(actions.getOrderDropdownError(e));
  }
}

function* watchGetOrderSupplier() {
  yield takeEvery(types.GET_ORDER_SUPPLIER_REQUEST, getOrderSupplierSaga);
}

function* watchAddOrderSupplier() {
  yield takeEvery(types.ADD_ORDER_SUPPLIER_REQUEST, addOrderSupplierSaga);
}

function* watchAddOrderSupplierBatch() {
  yield takeEvery(types.ADD_ORDER_SUPPLIER_BATCH_REQUEST, addOrderSupplierBatchSaga);
}

function* watchUpdateOrderSupplier() {
  yield takeEvery(types.UPDATE_ORDER_SUPPLIER_REQUEST, updateOrderSupplierSaga);
}

function* watchDeleteOrderSupplier() {
  yield takeEvery(types.DELETE_ORDER_SUPPLIER_REQUEST, deleteOrderSupplierSaga);
}

function* watchGetOrderSupplierDropdown() {
  yield takeEvery(types.GET_ORDER_SUPPLIER_DROPDOWN_REQUEST, getOrderSupplierDropdownSaga);
}

function* watchGetOrderDropdown() {
  yield takeEvery(types.GET_ORDER_DROPDOWN_REQUEST, getOrderDropdownSaga);
}

export function* orderSupplierSaga() {
  yield all([
    watchGetOrderSupplier(),
    watchAddOrderSupplier(),
    watchAddOrderSupplierBatch(),
    watchUpdateOrderSupplier(),
    watchDeleteOrderSupplier(),
    watchGetOrderSupplierDropdown(),
    watchGetOrderDropdown(),
  ]);
}
